"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _rcAnimate = _interopRequireDefault(require("rc-animate"));
var _rcProgress = _interopRequireDefault(require("rc-progress"));
var React = _interopRequireWildcard(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _Tooltip = _interopRequireDefault(require("../Tooltip"));
var _ykbStyledComponents = require("../ykb-styled-components");
var _classnames = _interopRequireDefault(require("classnames"));
var _StyledUpload = require("./StyledUpload");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
// https://developer.mozilla.org/en-US/docs/Web/API/FileReader/readAsDataURL
var previewFile = function previewFile(file, callback) {
  var reader = new FileReader();
  reader.onloadend = function () {
    return callback(reader.result);
  };
  reader.readAsDataURL(file);
};
var extname = function extname(url) {
  if (!url) {
    return '';
  }
  var temp = url.split('/');
  var filename = temp[temp.length - 1];
  var filenameWithoutSuffix = filename.split(/\#|\?/)[0];
  return (/\.[^./\\]*$/.exec(filenameWithoutSuffix) || [''])[0];
};
var isImageUrl = function isImageUrl(url) {
  var extension = extname(url);
  if (/^data:image\//.test(url) || /(webp|svg|png|gif|jpg|jpeg|bmp)$/.test(extension)) {
    return true;
  } else if (/^data:/.test(url)) {
    // other file types of base64
    return false;
  } else if (extension) {
    // other file types which have extension
    return false;
  }
  return true;
};
var UploadList = exports.default = /*#__PURE__*/function (_React$Component) {
  function UploadList() {
    var _this;
    (0, _classCallCheck2.default)(this, UploadList);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, UploadList, [].concat(args));
    (0, _defineProperty2.default)(_this, "handleClose", function (file) {
      var onRemove = _this.props.onRemove;
      if (onRemove) {
        onRemove(file);
      }
    });
    (0, _defineProperty2.default)(_this, "handlePreview", function (file, e) {
      var onPreview = _this.props.onPreview;
      if (!onPreview) {
        return;
      }
      e.preventDefault();
      return onPreview(file);
    });
    return _this;
  }
  (0, _inherits2.default)(UploadList, _React$Component);
  return (0, _createClass2.default)(UploadList, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;
      if (this.props.listType !== 'picture' && this.props.listType !== 'picture-card') {
        return;
      }
      (this.props.items || []).forEach(function (file) {
        if (typeof document === 'undefined' || typeof window === 'undefined' || !window.FileReader || !window.File || !(file.originFileObj instanceof File) || file.thumbUrl !== undefined) {
          return;
        }
        /*eslint-disable */
        file.thumbUrl = '';
        /*eslint-enable */
        previewFile(file.originFileObj, function (previewDataUrl) {
          /*eslint-disable */
          file.thumbUrl = previewDataUrl;
          /*eslint-enable */
          _this2.forceUpdate();
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props = this.props,
        prefixCls = _this$props.prefixCls,
        _this$props$items = _this$props.items,
        items = _this$props$items === void 0 ? [] : _this$props$items,
        listType = _this$props.listType,
        showPreviewIcon = _this$props.showPreviewIcon,
        showRemoveIcon = _this$props.showRemoveIcon,
        locale = _this$props.locale;
      var getList = function getList(theme) {
        return items.map(function (file) {
          var progress;
          var icon = /*#__PURE__*/React.createElement(_StyledUpload.StyledUploadDocTypeIcon, {
            $theme: theme,
            name: file.status === 'uploading' ? 'loading' : 'attach'
          });
          if (listType === 'picture' || listType === 'picture-card') {
            if (listType === 'picture-card' && file.status === 'uploading') {
              icon = /*#__PURE__*/React.createElement(_StyledUpload.StyledUploadUploadingText, {
                className: (0, _classnames.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-list-item-uploading-text"), !!prefixCls)),
                theme: theme
              }, locale.uploading);
            } else if (!file.thumbUrl && !file.url) {
              icon = /*#__PURE__*/React.createElement(_StyledUpload.StyledUploadListItemThumbnailIcon, {
                $theme: theme,
                name: "picture"
              });
            } else {
              var thumbnail = isImageUrl(file.thumbUrl || file.url) ? /*#__PURE__*/React.createElement("img", {
                src: file.thumbUrl || file.url,
                alt: file.name
              }) : /*#__PURE__*/React.createElement(_StyledUpload.StyledUploadListItemIcon, {
                name: "file",
                $theme: theme
              });
              icon = /*#__PURE__*/React.createElement(_StyledUpload.StyledUploadListItemThumbnail, {
                className: (0, _classnames.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-list-item-thumbnail"), !!prefixCls)),
                $theme: theme,
                onClick: function onClick(e) {
                  return _this3.handlePreview(file, e);
                },
                href: file.url || file.thumbUrl,
                target: "_blank",
                rel: "noopener noreferrer"
              }, thumbnail);
            }
          }
          if (file.status === 'uploading') {
            // show loading icon if upload progress listener is disabled
            var loadingProgress = 'percent' in file ? /*#__PURE__*/React.createElement(_rcProgress.default.Line, (0, _extends2.default)({}, _this3.props.progressAttr, {
              percent: file.percent
            })) : null;
            progress = /*#__PURE__*/React.createElement(_StyledUpload.StyledUploadListItemProgress, {
              className: (0, _classnames.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-list-item-progress"), !!prefixCls)),
              theme: theme,
              key: "progress"
            }, loadingProgress);
          }
          var preview = file.url ? /*#__PURE__*/React.createElement(_StyledUpload.StyledUploadListItemNameA, (0, _extends2.default)({}, file.linkProps, {
            className: (0, _classnames.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-list-item-name"), !!prefixCls)),
            href: file.url,
            target: "_blank",
            rel: "noopener noreferrer",
            theme: theme,
            onClick: function onClick(e) {
              return _this3.handlePreview(file, e);
            },
            title: file.name
          }), file.name) : /*#__PURE__*/React.createElement(_StyledUpload.StyledUploadListItemNameSpan, {
            theme: theme,
            className: (0, _classnames.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-list-item-name"), !!prefixCls)),
            onClick: function onClick(e) {
              return _this3.handlePreview(file, e);
            },
            title: file.name
          }, file.name);
          var style = {
            pointerEvents: 'none',
            opacity: 0.5
          };
          var previewIcon = showPreviewIcon ? /*#__PURE__*/React.createElement("a", {
            href: file.url || file.thumbUrl,
            target: "_blank",
            rel: "noopener noreferrer",
            style: file.url || file.thumbUrl ? undefined : style,
            onClick: function onClick(e) {
              return _this3.handlePreview(file, e);
            },
            title: locale.previewFile
          }, /*#__PURE__*/React.createElement(_Icon.default, {
            name: "eye-o"
          })) : null;
          var removeIcon = showRemoveIcon ? /*#__PURE__*/React.createElement(_StyledUpload.StyledUploadRemoveIcon, {
            $theme: theme,
            name: "close",
            title: locale.removeFile,
            onClick: function onClick() {
              return _this3.handleClose(file);
            }
          }) : null;
          var removeIconCross = showRemoveIcon ? /*#__PURE__*/React.createElement(_StyledUpload.StyledUploadRemoveIcon, {
            name: "close",
            $theme: theme,
            title: locale.removeFile,
            onClick: function onClick() {
              return _this3.handleClose(file);
            }
          }) : null;
          var actions = listType === 'picture-card' && file.status !== 'uploading' ? /*#__PURE__*/React.createElement(_StyledUpload.StyledUploadListItemActions, {
            className: (0, _classnames.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-list-item-actions"), !!prefixCls)),
            theme: theme
          }, previewIcon, removeIcon) : removeIconCross;
          var message;
          if (file.response && typeof file.response === 'string') {
            message = file.response;
          } else {
            message = file.error && file.error.statusText || locale.uploadError;
          }
          var iconAndPreview = file.status === 'error' ? /*#__PURE__*/React.createElement(_Tooltip.default, {
            overlay: message,
            title: message
          }, /*#__PURE__*/React.createElement(React.Fragment, null, icon, preview)) : /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(React.Fragment, null, icon, preview));
          return /*#__PURE__*/React.createElement(_StyledUpload.StyledUploadListItem, {
            theme: theme,
            $status: file.status,
            $listType: listType,
            key: file.uid,
            className: (0, _classnames.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-list-item"), !!prefixCls), "".concat(prefixCls, "-list-item-").concat(file.status), !!prefixCls))
          }, /*#__PURE__*/React.createElement(_StyledUpload.StyledUploadListItemInfo, {
            className: (0, _classnames.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-list-item-info"), !!prefixCls)),
            theme: theme
          }, iconAndPreview), actions, /*#__PURE__*/React.createElement(_rcAnimate.default, {
            transitionName: "fade",
            component: ""
          }, progress));
        });
      };
      var animationDirection = listType === 'picture-card' ? 'animate-inline' : 'animate';
      return /*#__PURE__*/React.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
        return /*#__PURE__*/React.createElement(_StyledUpload.StyledUploadListContainer, {
          theme: theme,
          listType: listType,
          prefixCls: prefixCls
        }, function (styledPrefixCls) {
          return /*#__PURE__*/React.createElement(_rcAnimate.default, {
            transitionName: "".concat(styledPrefixCls, "-").concat(animationDirection),
            component: "div",
            className: styledPrefixCls
          }, getList(theme));
        });
      });
    }
  }]);
}(React.Component);
(0, _defineProperty2.default)(UploadList, "defaultProps", {
  listType: 'text',
  // or picture
  progressAttr: {
    strokeWidth: 0.5,
    strokeColor: '#4691f3',
    strokeLinecap: 'round',
    showInfo: false
  },
  prefixCls: 'ykb-upload',
  showRemoveIcon: true,
  showPreviewIcon: true
});